import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [error, setError] = useState(false);
  const reload = useCallback(() => {
    api.get("/site").then((r) => setSite(r.data)).catch(() => setError(true));
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <SiteCtx.Provider value={{ site, error, reload }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
